export var condition = function condition(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get("/condition", {
        params: params
      });
    }
  };
};